module.exports = __webpack_public_path__ + "img/tier4-cost.b53374d.svg";